import { memo } from 'react';

import { AssetCustomFieldValueUpdateTaskCompletedPanelItem } from '~/components/AssetCustomFieldValueUpdateTasks/AssetCustomFieldValueUpdateTaskCompletedPanelItem';
import { AssetCustomFieldValueUpdateTaskFailedPanelItem } from '~/components/AssetCustomFieldValueUpdateTasks/AssetCustomFieldValueUpdateTaskFailedPanelItem';
import { AssetCustomFieldValueUpdateTaskInProgressPanelItem } from '~/components/AssetCustomFieldValueUpdateTasks/AssetCustomFieldValueUpdateTaskInProgressPanelItem';
import { PaneContainer } from '~/components/FileStatusTrackingPane/PaneContainer';
import { type AssetCustomFieldValueUpdateTask } from '~/store/tasks/types';

export type AssetCustomFieldValueUpdateTasksPanelProps = {
  tasks: AssetCustomFieldValueUpdateTask[];
  onCancel: (localTaskId: AssetCustomFieldValueUpdateTask['localTaskId']) => void;
  onClear: (localTaskId: AssetCustomFieldValueUpdateTask['localTaskId']) => void;
};

export const AssetCustomFieldValueUpdateTasksPanel = memo(
  ({ tasks, onCancel, onClear }: AssetCustomFieldValueUpdateTasksPanelProps) => {
    const renderTaskItem = (task: AssetCustomFieldValueUpdateTask) => {
      switch (task.status) {
        case 'in-progress':
          return <AssetCustomFieldValueUpdateTaskInProgressPanelItem onCancel={() => onCancel(task.localTaskId)} />;
        case 'completed':
          return (
            <AssetCustomFieldValueUpdateTaskCompletedPanelItem
              metadata={task.metadata}
              onClear={() => onClear(task.localTaskId)}
            />
          );
        default:
          return <AssetCustomFieldValueUpdateTaskFailedPanelItem onClear={() => onClear(task.localTaskId)} />;
      }
    };

    return (
      <div data-testid="ASSET_CUSTOM_FIELD_VALUE_UPDATE_TASKS_PANEL">
        {tasks.map((task) => {
          return (
            <PaneContainer key={task.localTaskId} className="mb-2 last:mb-0">
              {renderTaskItem(task)}
            </PaneContainer>
          );
        })}
      </div>
    );
  },
);

AssetCustomFieldValueUpdateTasksPanel.displayName = 'AssetCustomFieldValueUpdateTasksPanel';
